import { schema } from "normalizr";

export const cartPreviewSchema = new schema.Entity("cartPreviews");
export const cartSchema = new schema.Entity("carts");

